<template>
    <section class="alert alert-info w-100">
        <p class="font-weight-bold text-uppercase">Previous claims</p>
        <div class="mb-3" v-for="claim in invoice.previous_claims">
            <div class="row">
                <span class="col">
                    Service Date:
                    {{
                        helpers._get(claim, "charges.0.serviced_at", false)
                            ? moment(helpers._get(claim, "charges.0.serviced_at", false)).format(
                                  "MM/DD/YYYY"
                              )
                            : ""
                    }}
                </span>
                <span class="col"> Status: {{ claim.internal_status }} </span>
            </div>
            <div class="row">
                <span class="col"> Patient: {{ claim.client_name }} </span>
                <span class="col">
                    Charge amount: {{ helpers.formatMoney(claim.claim_amount) }}
                </span>
            </div>
            <div class="row">
                <span class="col"> Contract: {{ claim.funding_source }} </span>
                <span class="col">
                    Payment amount: {{ helpers.formatMoney(claim.payment_amount) }}
                </span>
            </div>
        </div>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";

export default {
    name: "FundingSourcesPreviousClaim",
    props: ["invoice"],
    data() {
        return {
            helpers,
        };
    },
};
</script>

<style scoped></style>
